import React from "react";
import { useParams } from "react-router";
import AbnormalMotionEvent from "./AbnormalMotionEvent";
import UnplannedMedicalVisits from "./UnplannedMedicalVisits";
import CurrentMedications from "./CurrentMedications";
import MedicationAdherence from "./MedicationAdherence";
import Symptoms from "./Symptoms";
import HRM from "./HRM";
import Help from "./Help";
import FallEvent from "./FallEvent";
import SafeLocationAlerts from "./SafeLocationAlerts";
import Footer from "../GenericComponents/Footer";
import "./DrillDownPage.css";

const PatientEventDrillDown = () => {
  const { eventType } = useParams();
  //console.log('eventType', eventType)
  return (
    <div className="drilldown-route">
      <div className="drilldown-route__content">
        {eventType === "abnormal" && <AbnormalMotionEvent />}
        {eventType === "unplannedMedicalVisits" && <UnplannedMedicalVisits />}
        {eventType === "currentMedications" && <CurrentMedications />}
        {eventType === "medicationAdherence" && <MedicationAdherence />}
        {eventType === "symptoms" && <Symptoms />}
        {eventType === "hrm" && <HRM />}
        {eventType === "help" && <Help />}
        {eventType === "fallEvent" && <FallEvent />}
        {eventType === "safeLocationAlerts" && <SafeLocationAlerts />}
      </div>
      <Footer />
    </div>
  );
};

export default PatientEventDrillDown;
